
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import 'datatables.net'
import 'datatables.net-bs4'
import 'daterangepicker'
import 'moment'
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/clike/clike.js';
import 'codemirror/mode/php/php.js';
import 'codemirror/mode/vbscript/vbscript.js';
import 'slick-carousel'
import { TempusDominus} from '@eonasdan/tempus-dominus';
import {TabulatorFull as Tabulator} from 'tabulator-tables';
import Lang from 'lang.js'
import messages from './common/lar_locale.js'
import Alpine from 'alpinejs'
window.Alpine = Alpine
import Inputmask from "inputmask";
window.Inputmask = Inputmask;
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';



const lang = new Lang({ messages })

try {
	window.$ = window.jQuery = require('jquery');
	require('jquery-ui/dist/jquery-ui.js');
	window.bootstrap = require('bootstrap');
	window.Stepper = require('bs-stepper');
	window.moment = require('moment');
	window.Dropzone = require('dropzone').default;
	Dropzone.autoDiscover = false;
	window.CodeMirror = require('codemirror');
	window.Masonry = require('masonry-layout/dist/masonry.pkgd.min.js');
	window.TempusDominus = TempusDominus;
	window.Tabulator = Tabulator;
	window.lang = lang
	
	moment.locale('pt')

	require('select2');
	/*$('select').select2({
		language:'pt'
	});*/
} catch (e) {}

// Corrigir os paths dos ícones (Leaflet procura por default em /images/)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: '/images/marker-icon-2x.png',
    iconUrl: '/images/marker-icon.png',
    shadowUrl: '/images/marker-shadow.png',
});
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });